<template>
  <div class="download-page">
    <popup-email-sent v-if="isShowPopupEmailSent" />
    <div class="banner">
      <div
        class="banner-button-back-mobile"
        @click="$router.push({ path: '/' })"
      >
        <img src="@/assets/icon/arrow-left-white.svg" />
        <span>Back</span>
      </div>
      <div class="banner-img">
        <div class="logo-container">
          <img
            class="top-logo"
            src="@/assets/img/teaser-main-logo.svg"
            @click="$router.push({ path: '/' })"
          />
          <a href="https://www.soco.id">
            <img class="soco-logo" src="@/assets/img/header-logo-soco.svg" />
          </a>
        </div>
      </div>
      <div class="banner-tagline">
        <span class="tagline-download">Download</span><br class="mobile-gone" />
        comprehensive & in-depth <br class="mobile-gone" />
        <span class="tagline-beauty-report">beauty reports</span> here
        <div class="tagline-long">
          Gathered from beauty enthusiasts, <br />
          for data-driven and actionable insights.
          <br /><br />
          Utilizing advanced algorithms and analysis, <br />
          InsightFactory provides you with
          <br />
          exclusive report and publications regarding <br />
          the beauty industry landscape.
        </div>
      </div>
      <img
        class="banner-bottom-img"
        src="@/assets/img/download-page/mobile-banner.png"
      />
    </div>
    <submit-form></submit-form>
  </div>
</template>
<script>
export default {
  components: {
    SubmitForm: () => import("./components/formUser.vue"),
    PopupEmailSent: () => import("./components/popupEmailSent.vue"),
  },
  computed: {
    isShowPopupEmailSent() {
      return this.$store.state.$_User.showPopup;
    },
  },
  mounted() {
    if (!this.$store.state.$_User.selectedReport.name) {
      this.$router.push("/");
    }
  },
};
</script>
<style lang="scss" scoped>
.logo-container {
  display: flex;
  width: 240px;
  gap: 10px;
  flex-direction: column;
  align-items: flex-end;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
}

@media (max-width: 1170px) {
  .mobile-gone {
    display: none;
  }
  .banner {
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 1s ease-in-out;
  }
  .banner-button-back-mobile {
    cursor: pointer;
    user-select: none;
    display: inherit;
    color: #ffffff;
    font-family: $lato;
    font-size: 16px;
    font-weight: 700;
    line-height: 19.2px;
    text-align: left;
    display: flex;
    align-items: center;
    width: 100%;
    img {
      margin-left: 16px;
    }
    span {
      padding: 16px 8px;
    }
  }

  .banner-img {
    width: 50vw;
    display: flex;
    justify-content: center;
    margin-left: -40px;
  }

  .banner-tagline {
    font-family: $lato;
    text-align: center;
    color: #ffffff;
    font-size: 22px;
    font-weight: 300;
    line-height: 32px;
    text-align: center;
    margin-top: 20px;
    padding: 0 40px;

    .tagline-download {
      font-size: 22px;
      font-weight: 900;
      line-height: 32px;
      white-space: nowrap;
    }

    .tagline-beauty-report {
      font-weight: 800;
      line-height: 44px;
      background: #cd2b75;
      border-radius: 22px;
      padding: 4px 12px;
    }

    .tagline-long {
      padding-top: 34px;
      margin: 0 -40px;
      width: 100vw;
      font-size: 14px;
      font-weight: 600;
      line-height: 22px;
    }
  }

  .banner-bottom-img {
    width: 95%;
    object-fit: contain;
    margin-top: auto;
  }
}

@media (min-width: 1170px) and (max-width: 1300px) {
  .banner-tagline {
    right: 80px;
  }
}

@media (min-width: 1170px) {
  .padding-right {
    padding-right: 45vw;
  }
  .banner-button-back-mobile {
    display: none;
  }
  .banner-bottom-img {
    display: none;
  }
  .download-page {
    display: flex;
    height: 100%;
    width: 100%;
    background: #ffffff;
  }

  .banner {
    display: block;
    position: relative;
    height: 100%;
    width: 100%;
    background-image: url("@/assets/img/download-page/desktop-banner.png");
    background-repeat: no-repeat;
    background-position: bottom left;
    background-size: auto 50%;
    background-color: $insightFactoryRed;
  }

  .banner-img {
    margin-left: 60px;
    margin-top: 10vh;
  }

  .banner-tagline {
    position: absolute;
    right: 100px;
    top: calc(10vh + 50px);
    font-family: $lato;
    font-size: 30px;
    font-weight: 300;
    line-height: 40px;
    text-align: left;
    color: #ffffff;

    .tagline-download {
      font-weight: 900;
    }

    .tagline-beauty-report {
      font-weight: 800;
      line-height: 44px;
      background: #cd2b75;
      border-radius: 22px;
      padding: 4px 12px;
      margin-left: -12px;
    }

    .tagline-long {
      padding-top: 34px;
      font-family: $lato;
      font-size: 17px;
      font-weight: 600;
      line-height: 25px;
    }
  }
}
</style>
